// extracted by mini-css-extract-plugin
export var container = "_b7-0";
export var icon = "_b7-1";
export var text = "_b7-2";